module.exports = __webpack_public_path__ + "static/media/DMC3-FM3.0b1c8c6d.czml";